import Cookies from 'js-cookie';
import * as ActionTypes from '../Constants/actionTypes';
import { API_LOGIN, API_REFRESH_TOKEN, CHANGE_PASSWORD_TEMP } from '../Constants/apiUrls';
import { jwtDecode } from 'jwt-decode';
import { setupTokenRefreshTimeout } from '../Middleware/tokenUtils'; // Import the utility
import { persistor } from '../Store/configureStore';
import Swal from "sweetalert2";



export const login = (email, password) => async dispatch => {


  console.log("Login function called with email:", email);
  dispatch({ type: ActionTypes.LOGIN_REQUEST });
  try {
    const response = await fetch(API_LOGIN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, password }),
    });

    const data = await response.json();

   

    if (response.ok) {
      console.log("Succesfull Jhal");
      const decodedToken = jwtDecode(data.access);
      const accessTokenExpiry = decodedToken.exp * 1000; // Convert to milliseconds

      // Clear existing cookies to avoid duplicates
      Cookies.remove('accessToken');
      Cookies.remove('refreshToken');
      Cookies.remove('accessTokenExpiry');
      Cookies.remove('passwordExpired');
      Cookies.remove('confirmedPasswordExpired');

      // Set new cookies
      Cookies.set('accessToken', data.access, { expires: new Date(accessTokenExpiry), secure: true, sameSite: 'Lax' });
      Cookies.set('accessTokenExpiry', accessTokenExpiry, { secure: true, sameSite: 'Lax' });
      Cookies.set('refreshToken', data.refresh, { expires: 30, secure: true, sameSite: 'Lax' });
      localStorage.setItem('WhatNewPopup', true);





      dispatch({
        type: ActionTypes.LOGIN_SUCCESS,
        payload: { accessToken: data.access, refreshToken: data.refresh, userData: decodedToken },
      });



    } else {
      if (data.error && data.temporary_token) {
        // If password expired, save temporary token
        // Save temporary token in Cookies
        Cookies.set('temporaryToken', data.temporary_token, { secure: true, sameSite: 'Strict' });

        // Store `passwordExpired` in Cookies so it persists
        Cookies.set('passwordExpired', 'true', { secure: true, sameSite: 'Strict' });
        Cookies.set('confirmedPasswordExpired', 'false', { secure: true, sameSite: 'Strict' });


        // Dispatch PASSWORD_EXPIRED to trigger redirection in App.js
        dispatch({
          type: ActionTypes.PASSWORD_EXPIRED,
          payload: { errorMessage: data.error, temporaryToken: data.temporary_token },
        });

        // Show SweetAlert first, then set state for redirection
        Swal.fire({
          title: "Password Expired",
          text: data.error || "Your password has expired. Please change your password to continue.",
          icon: "warning",
          confirmButtonText: "Change Password",
          confirmButtonColor: "#052140",
          allowOutsideClick: false,
          customClass: {
            title: 'swal-title-custom',
            text: 'swal-text-custom',
          }
        }).then(() => {
          Cookies.set('confirmedPasswordExpired', 'true', { secure: true, sameSite: 'Strict' });

          // Delay dispatch to allow cookies to update
          setTimeout(() => {
            dispatch({ type: ActionTypes.CONFIRM_PASSWORD_EXPIRED });
            window.location.href = '/change-password';
          }, 500);
        });

      } else {
        dispatch({ type: ActionTypes.LOGIN_FAILURE, payload: data.message || 'Incorrect email or password' });
      }


      // const errorData = await response.json();
      // dispatch({
      //   type: ActionTypes.LOGIN_FAILURE,
      //   payload: errorData.message || 'Incorrect email or password',
      // });
    }
  } catch (error) {
    dispatch({
      type: ActionTypes.LOGIN_FAILURE,
      payload: 'Something went wrong. Please try again later.',
    });
  }
};

export const logout = () => async (dispatch) => {
  // Clear auth cookies
  Cookies.remove('accessToken');
  Cookies.remove('refreshToken');
  Cookies.remove('accessTokenExpiry');
  Cookies.remove('temporaryToken');
  Cookies.remove('passwordExpired');
  Cookies.remove('confirmedPasswordExpired');

  // Clear auth/session-related local and session storage keys
  localStorage.removeItem('WhatNewPopup');
  localStorage.removeItem('IsDisclaimerAccepted');
  sessionStorage.removeItem('pendingHelixOpsEmail');
  sessionStorage.removeItem('whatsNewShownThisSession');

  dispatch({ type: ActionTypes.LOGOUT });

  try {
    await persistor.flush();
    await persistor.purge();
  } catch {
    // Still redirect; session boundary must complete even if persist cleanup fails
  }

  window.location.assign('/login');
};


// export const refreshToken = () => async dispatch => {
//   const refresh = Cookies.get('refreshToken');

//   if (!refresh) {
//     dispatch(logout());
//     return;
//   }

//   try {
//     const response = await fetch(API_REFRESH_TOKEN, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ refresh }),
//     });

//     if (response.ok) {
//       const data = await response.json();
//       if (data.access) {
//         const decodedToken = jwtDecode(data.access);
//         const accessTokenExpiry = decodedToken.exp * 1000; // Convert to milliseconds

//         // Clear existing cookies to avoid duplicates
//         Cookies.remove('accessToken');
//         Cookies.remove('accessTokenExpiry');

//         // Set new cookies
//         Cookies.set('accessToken', data.access, { expires: new Date(accessTokenExpiry), secure: true, sameSite: 'Lax' });
//         Cookies.set('accessTokenExpiry', accessTokenExpiry, { secure: true, sameSite: 'Lax' });

//         dispatch({ type: ActionTypes.REFRESH_TOKEN_SUCCESS, payload: { accessToken: data.access, userData: decodedToken } });
//       } else {
//         throw new Error('Access token missing in response');
//       }
//     } else {
//       throw new Error(`Failed to refresh token. Status: ${response.status}, ${response.statusText}`);
//     }
//   } catch (error) {
//     console.error('Error refreshing token:', error);
//     dispatch(logout()); // Ensure user is logged out if refresh fails
//   }
// };


export const refreshToken = () => async dispatch => {
  const refresh = Cookies.get('refreshToken');

  if (!refresh) {
    dispatch(logout());
    return;
  }

  try {
    const response = await fetch(API_REFRESH_TOKEN, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh }),
    });

    if (response.ok) {
      const data = await response.json();
      const decodedToken = jwtDecode(data.access);
      const accessTokenExpiry = decodedToken.exp * 1000; // Convert to milliseconds

      // Clear existing cookies and set new tokens
      Cookies.set('accessToken', data.access, { expires: new Date(accessTokenExpiry), secure: true, sameSite: 'Lax' });
      Cookies.set('accessTokenExpiry', accessTokenExpiry, { secure: true, sameSite: 'Lax' });

      dispatch({
        type: ActionTypes.REFRESH_TOKEN_SUCCESS,
        payload: { accessToken: data.access, userData: decodedToken }
      });

      // Set up the next automatic refresh based on the new token's expiry
      setupTokenRefreshTimeout(accessTokenExpiry, dispatch, refreshToken, logout);  // Add refreshToken and logout

    } else {
      throw new Error('Failed to refresh token');
    }
  } catch (error) {
    console.error('Error refreshing token:', error);
    dispatch(logout());  // Ensure the user is logged out if the refresh fails
  }
};


export const changePassword = (oldPassword, newPassword, cnewPassword, navigate) => async dispatch => {
  dispatch({ type: ActionTypes.CHANGE_PASSWORD_REQUEST_TEMP });

  const temporaryToken = Cookies.get('temporaryToken');
  if (!temporaryToken) {
    dispatch({ type: ActionTypes.CHANGE_PASSWORD_FAILURE_TEMP, payload: "Session expired" }); 
    Swal.fire({
      title: 'Error',
      text: 'Your session has expired. Please log in again.',
      icon: 'error',
      confirmButtonText: 'OK',
      confirmButtonColor: "#052140",
    }).then(() => {
      window.location.href = '/'; // Redirect to login
    });
    return;
  }

  try {
    const response = await fetch(CHANGE_PASSWORD_TEMP, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${temporaryToken}` // Use temporary token
      },
      body: JSON.stringify({ oldPassword, newPassword, cnewPassword })
    });

    const data = await response.json();

    if (response.ok) {
      // Remove temporary token
      Cookies.remove('temporaryToken');
      Cookies.remove('passwordExpired');
      Cookies.remove('confirmedPasswordExpired');

      dispatch({ type: ActionTypes.CHANGE_PASSWORD_SUCCESS_TEMP });

      Swal.fire({
        title: 'Success',
        text: 'Your password has been changed successfully. Please log in again.',
        icon: 'success',
        confirmButtonText: 'Login',
        confirmButtonColor: "#052140",
      }).then(() => {
        navigate('/'); // Redirect to login
      });

    } else {
      if (data?.error === 'Unauthorized') {
        dispatch({ type: ActionTypes.CHANGE_PASSWORD_FAILURE_TEMP, payload: "Session expired" });
        Cookies.remove('temporaryToken');
        Cookies.remove('passwordExpired');
        Cookies.remove('confirmedPasswordExpired');

        Swal.fire({
          title: 'Error',
          text: 'Your session has expired. Please log in again.',
          icon: 'error',
          confirmButtonText: 'Log In',
          confirmButtonColor: "#052140",
        }).then(() => {
          window.location.href = '/';
        });
      } else {
        throw new Error(data?.error);
      }
    
    }
  } catch (error) {
    dispatch({ type: ActionTypes.CHANGE_PASSWORD_FAILURE_TEMP, payload: error.message });



    if (error?.message === 'Unauthorized') {
      Cookies.remove('temporaryToken');
      Cookies.remove('passwordExpired');
      Cookies.remove('confirmedPasswordExpired');

      Swal.fire({
        title: 'Error',
        text: 'Your session has expired. Please log in again.',
        icon: 'error',
        confirmButtonText: 'Login',
        confirmButtonColor: "#052140",
      }).then(() => {
        window.location.href = '/';
      });
    } else {
      Swal.fire({
        title: 'Error',
        text: error.message,
        icon: 'error',
        confirmButtonText: 'Retry',
        confirmButtonColor: "#052140",
      });
    }
  }
};